import React from 'react';
import { Stack, Typography } from '@mui/material';
import { Construction } from '@mui/icons-material';

interface Props {
  title?: string;
  description?: string;
}

export const WorkInProgressView = ({
  title = 'Functionality in development',
  description = 'This section is under development and will be available soon.',
}: Props) => (
  <Stack flex={1} gap={1} alignItems="center" justifyContent="center" sx={{ minHeight: '16rem', py: 6 }}>
    <Construction sx={{ fontSize: '3rem', color: 'text.disabled' }} />

    <Typography variant="h6" color="text.secondary" alignItems="center" textAlign="center">
      {title}
    </Typography>

    <Typography variant="body2" color="text.disabled" textAlign="center">
      {description}
    </Typography>
  </Stack>
);
